<template>
  <div class="icon-body" @dblclick="dblclick()" draggable="true">
    <div style="display: flex;flex-wrap: nowrap">
      <el-icon v-if="item.no_access" class="lock">
        <ElIconLock></ElIconLock>
      </el-icon>
      <my-icon :name="item.icon" :size="50" :enable="!item.disabled&&!item.no_access"></my-icon>
      <el-badge type="danger" :value="badgeNum" class="badgeStyle" v-show="badgeNum!==0"></el-badge>
    </div>
    <div class="text">{{ item.name }}</div>
  </div>
</template>

<script>
export default {
  name: "GroupAppIcon",
  props: {
    item: Object
  },
  computed: {
    badgeNum() {
      let key = this.item?.badge_data_key;
      if (!key) {
        return 0;
      }

      return this.$store.getters['core/getBadgeData'](key) || 0
    }
  },
  methods: {
    dblclick() {
      if (this.item.disabled) {
        return this.$message.error(this.$t('no_use', {name: this.item?.name}))
      } else if (this.item?.no_access) {
        return this.$message.error(this.$t('no_access', {name: this.item?.name}))
      }
      if (this.item.link_url) {
        window.open(this.item.link_url, "_blank");
        return;
      }

      let windowObj = {}
      windowObj.icon = this.item.icon;
      windowObj.component = this.item.component
      windowObj.componentParam = this.item.params
      windowObj.name = this.item.name;
      windowObj.badge_data_key = this.item.badge_data_key;
      windowObj.parentData = {
        form_component: this.item?.jsonObj?.form_component,
        show_tips: this.item?.jsonObj?.show_tips ?? false,
      }

      let win = this.item?.jsonObj?.window || {};
      windowObj.width = win.width || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.height = win.height || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.max = true;//win.max || this.$store.getters['core/getGlobalWindowMax']
      windowObj.max_icon = win.max_icon
      windowObj.min_icon = win.min_icon

      this.$store.dispatch('core/openWindow', windowObj)

    }
  }
}
</script>


<style lang="less" scoped>
.icon-body {
  /*border:2px solid transparent;*/
  border-radius: 4px;
  width: 110px;
  height: 110px;
  padding-top: 10px;
  position: relative;

  .badgeStyle {
    position: absolute;
    top: 10px;
    left: 70px;
    z-index: 1;
  }

  .lock {
    font-size: 18px;
    color: darkgoldenrod;
    position: absolute;
    left: 0;
    top: 0;
  }

  .text {
    min-height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: large;
    margin-top: 10px;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    padding-bottom: 5px;
  }
}

.context-menu-section {
  position: absolute;
}
</style>
